// extracted by mini-css-extract-plugin
export var box = "simplymeet-module--box--a9eb4";
export var firstBox = "simplymeet-module--firstBox--7bc53";
export var frameBox = "simplymeet-module--frameBox--fbba4";
export var heading = "simplymeet-module--heading--c9b13";
export var leftBox = "simplymeet-module--leftBox--cd244";
export var rightBox = "simplymeet-module--rightBox--c8c2c";
export var simplymeet = "simplymeet-module--simplymeet--e260f";
export var simplymeetWrapper = "simplymeet-module--simplymeet-wrapper--6ce77";
export var staff = "simplymeet-module--staff--6f1a5";
export var staffBox = "simplymeet-module--staffBox--2d325";